<template>
    <div>
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('reports.loyaltyPoints')"></general-top-bar> -->
      <!--End General Top Bar -->
      <div class="col-md-12 card text-left">
        <div class="card-header"></div>
        <div class="report-filters">
          <div class="col-md-4 col-sm-6 col-xs-12 form-group pull-left">
            <input type="text" :placeholder="$t('reports.searchEmployee')" class="form-control" v-model="clients.searchEmployee">
          </div>
          <div class="col-md-4 col-sm-6 col-xs-12 form-group pull-left">
            <input type="text" :placeholder="$t('reports.searchClient')" class="form-control" v-model="clients.searchClient">
          </div>
          <div class="col-md-2 col-sm-6 col-xs-12 form-group pull-left date-range">
            <el-date-picker
              type="daterange"
              v-model="clients.valid"
              class="mid"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :name="pickerNames"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="search-button-reports col-md-2 col-sm-6 col-xs-12 form-group pull-left">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="getClients(null)"><i class="ti-search"></i></div>
          </div>
        </div>
        <div class="card-content total-pagination pad-15">
          <data-tables-server
            class=""
            @query-change="paginationChanged"
            v-loading="loading"
            :data="clientsTableData"
            :search-def="{ show: false }"
            :total="totalClients"
            :pagination-props="paginationProps"
            :table-props="tableOptions"
            style="width: 100%;"
          >
            <el-table-column :min-width="80" prop="name" label="Operator">
              <template slot-scope="props">
                {{ props.row.creater.firstname }} {{ props.row.creater.lastname }}
              </template>
            </el-table-column>
            <el-table-column :min-width="80" prop="name" label="Client">
              <template slot-scope="props">
                {{ props.row.user.firstname }} {{ props.row.user.lastname }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              prop="user.email"
              :label="$t('reports.email')"
            ></el-table-column>
            <el-table-column
              :min-width="60"
              prop="user.phone"
              :label="$t('reports.phone')"
            ></el-table-column>
            <!-- <el-table-column
              :min-width="40"
              sortable="custom"
              prop="user.loyalty_points"
              :label="$t('reports.gender')"
            ></el-table-column> -->
            <el-table-column :min-width="80" prop="name" label="Puncte Folosite">
              <template slot-scope="props">
                <span class="pad-lf-30">{{ props.row.points_spent }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              prop="orders_count"
              label="Echivalent"
            >
              <template slot-scope="props">
                <b>{{ parseFloat(props.row.points_to_money).toFixed(2)}} {{ currency }}</b>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
</template>
<script>
  import moment from 'moment'
  import {DatePicker} from 'element-ui'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
  export default {
    components: {
      // GeneralTopBar,
      [DatePicker.name]: DatePicker,
      ChartCard,
      ChartBarsCard,
      ChartPieCard
    },
    props: {
      isLoyaltyPoints: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isLoyaltyPoints () {
        if (this.isLoyaltyPoints) {
          let firstQuery = {
            sort: {
              prop: 'name',
              order: 'asc'
            },
            page: 1,
            pageSize: 20
          }
          this.getData(firstQuery)
        }
      }
    },
    created () {
      this.getClients()
    },
    data () {
      return {
        loading: false,
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        clients: {
          'valid': [
            moment().date(1).format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          searchClient: null,
          searchEmployee: null
        },
        paginationProps: {
          // pageSizes: [5, 10, 15],
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {
          defaultSort: {
            prop: 'name',
            order: 'ascending'
          }
        },
        labels: null,
        labelingPrimaryOption: null,
        totalClients: null,
        sortBy: 'name',
        sortOrder: 'asc',
        clientsTableData: [],
        pickerOptions: {
          disabledDate (date) {
            return date < moment().subtract(12, 'months').startOf('day')
          }
        },
        pickerNames: ['date_from', 'date_to']
      }
    },
    methods: {
      paginationChanged (query) {
        if (query.type === 'page') this.getClients(query)
        if (query.type === 'size') this.getClients(query)
        if (query.type === 'sort') {
          if (query.sort.order) {
            this.sortBy = query.sort.prop
            this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
          } else {
            this.sortBy = 'name'
            this.sortOrder = 'asc'
          }
          this.getClients(query)
        }
      },
      getClients (query) {
        if (!this.isLoyaltyPoints) {
          return
        }
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          start_date: this.clients.valid[0],
          end_date: this.clients.valid[1],
          search_client: this.clients.searchClient,
          search_employee: this.clients.searchEmployee
        }

        let sortColumn = ''
        let sortType = ''
        // let $dd = {}
        if (query) {
          sortColumn = query.sort.prop
          sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
        } else {
          sortColumn = this.sortBy
          sortType = this.sortOrder
        }

        const sortOptions = {
          field: sortColumn,
          order: sortType
        }
        data = {
          ...data,
          ...sortOptions
        }

        this.loading = true
        const pageSize = query ? query.pageSize : 20
        const page = query ? query.page : 1
        this.apiRequest('/reports/loyalty-points?page=' + page + '&pageSize=' + pageSize, 'GET', data, response => {
          if (response.status === true) {
            this.clientsTableData = response.data.data
            this.totalClients = response.data.total
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      goToRecordCustomer (row, event, column) {
        window.open(`/#/reports/customer/${row.id}`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/LoyaltyPoints.vue